<onyx-section heading="labels.officeNote">
  <h6 rightHeading class="optional">
    {{ 'labels.optional' | translate }}
  </h6>

  <form>
    <onyx-textarea
      data-testid="content-textarea"
      [formControl]="form().controls.content"
      [minResizeHeight]="minResizeHeight()"
      [placeholder]="placeholder()"
    ></onyx-textarea>
  </form>
</onyx-section>
